import { Component, OnInit } from '@angular/core';
import { CommonService } from '../service/Security/common.service';
import { APIFactoryEndPoints } from '../common/apifactory-end-points';
import { LocalStorageService } from '../common/LocalStorageService';
import { NotificationSetupService } from '../service/NotificationSetup/notification-setup.service';
import { Subscription } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorLog } from '../model/Common/error-log';
import moment from 'moment';
import { Constant } from '../common/constant';
import { MainContainerService } from '../service/main-container.service';
import { MonitoringDashboardDto } from '../model/MonitoringDashboard/monitoring-dashboard-dto';
import { MonitoringDashboardCommon } from '../model/MonitoringDashboard/monitoring-dashboard-common';
import { OrderDashboardDto } from '../model/MonitoringDashboard/order-dashboard-dto';
import { Order } from '../model/MonitoringDashboard/order';
import { ReturnOrder } from '../model/MonitoringDashboard/application-dto';
import { WebsocketService } from '../service/WebSocket/websocket.service';
import { ToastService } from '../service/toast.service';
//import { Frame, Message } from 'stompjs';
import { IMessage } from '@stomp/stompjs';
import { CapitalFoodsComponent } from '../Module/Order/WebOrder/capital-foods/capital-foods.component';

@Component({
  selector: 'monitoring-dashboard',
  templateUrl: './monitoring-dashboard.component.html',
  styleUrls: ['./monitoring-dashboard.component.css']
})
export class MonitoringDashboardComponent {

  errorLog: ErrorLog = new ErrorLog();
  loginLocation: string
  monitoringDashboardDto: MonitoringDashboardDto = new MonitoringDashboardDto();
  dashboardDtoForWebOrderList: MonitoringDashboardCommon[] = [];
  dashboardDtoForTrackList: MonitoringDashboardCommon[] = [];
  dashboardDtoForResponseList: MonitoringDashboardCommon[] = [];
  orderDashboardDto: OrderDashboardDto = new OrderDashboardDto();
  returnOrderDashboardDto: OrderDashboardDto = new OrderDashboardDto();
  ordersList: Order[] = [];
  returnOrdersList: ReturnOrder[] = [];
  name: string;
  selectedInventory: number | string;
  selectedReturnInventory: number | string;
  activeSort: string = '';
  userId: string = '';
  btnValues: string[] = ['Today', 'Current Week', 'Current Month', 'Current Quarter', 'Current Fin Year'];

  //Subscription
  private getDynamicDataSub: Subscription;
  private insertErrorLogSubscription: Subscription;
  private socketSubscription: Subscription;
  private updateFilterTypeSubscription: Subscription;
  private getDashboardSubscription: Subscription;
  private timer: any;

  constructor(private commonService: CommonService,
    private apiUrl: APIFactoryEndPoints,
    public persistenceService: LocalStorageService,
    public notificationSetupService: NotificationSetupService,
    // private capitalFoodsComponent: CapitalFoodsComponent,
    private constant: Constant,
    private containerService: MainContainerService,
    private webSocketService: WebsocketService,
    private toastService: ToastService
  ) {

  }

  ngOnInit() {
    this.setInitialDataToZero();
    this.getMonitoringDasboarddata('Today');
    this.activeSort = 'Today';
    this.startTimer();

    // this.userId = this.persistenceService.get('userId');
    // this.subscribeToNotifications('monitoring-dashboard-' + this.userId);
    // this.getDynamicDataSub = this.persistenceService.monitoringDashboardData$.subscribe(data => {
    // if (data) {
    // this.monitoringDashboardDto = JSON.parse(data);
    // }
    // });
  }

  setInitialDataToZero() {
    this.setDataToDiv();
    this.ordersList = this.monitoringDashboardDto.application.orders;
    if (!this.selectedInventory) {
      this.selectedInventory = 'all';
    }
    this.onSelectOrderType(this.selectedInventory);
    this.returnOrdersList = this.monitoringDashboardDto.application.returnOrders;
    if (!this.selectedReturnInventory) {
      this.selectedReturnInventory = 'all';
    }
    this.onSelectReturnOrderType(this.selectedInventory);
  }

  ngOnDestroy() {
    if (this.getDynamicDataSub !== undefined) {
      this.getDynamicDataSub.unsubscribe();
    }

    if (this.insertErrorLogSubscription !== undefined) {
      this.insertErrorLogSubscription.unsubscribe();
    }

    if (this.socketSubscription !== undefined) {
      this.socketSubscription.unsubscribe();
    }

    if (this.updateFilterTypeSubscription !== undefined) {
      this.updateFilterTypeSubscription.unsubscribe();
    }

    this.stopTimer();
  }

  onSelectOrderType(invCode: string | number) {
    if (invCode === 'all') {
      // Aggregate all values from ordersList
      let totalUnresolved = 0, totalInProcess = 0, totalDispatched = 0, totalReceived = 0, totalOrders = 0, totalConfirmed = 0, totalDeclined = 0;
      this.ordersList.forEach(c => {
        totalUnresolved += c.unResolved;
        totalInProcess += c.inProcess;
        totalDispatched += c.dispatched;
        totalReceived += c.received;
        totalOrders += c.totalOrders;
        totalConfirmed += c.confirmed;
        totalDeclined += c.declined;
      });

      // Set aggregated values to orderDashboardDto
      this.orderDashboardDto.subHeading = 'All Orders';
      this.orderDashboardDto.firstHeading = "UnResolved";
      this.orderDashboardDto.redColor = totalUnresolved;
      this.orderDashboardDto.secondHeading = "In Process";
      this.orderDashboardDto.lightYellow = totalInProcess;
      this.orderDashboardDto.thirdHeading = "Dispatched";
      this.orderDashboardDto.darkYellow = totalDispatched;
      this.orderDashboardDto.fourthHeading = "Received";
      this.orderDashboardDto.greenColor = totalReceived;
      this.orderDashboardDto.fifthHeading = "Total";
      this.orderDashboardDto.greyColor = totalOrders;
      this.orderDashboardDto.confirmed = totalConfirmed;
      this.orderDashboardDto.declined = totalDeclined;

    } else {
      // Find and display values for the selected inventory item
      this.ordersList.forEach(c => {
        if (invCode == c.inventoryCode) {
          this.orderDashboardDto.subHeading = c.inventoryName;
          this.orderDashboardDto.firstHeading = "UnResolved";
          this.orderDashboardDto.redColor = c.unResolved;
          this.orderDashboardDto.secondHeading = "In Process";
          this.orderDashboardDto.lightYellow = c.inProcess;
          this.orderDashboardDto.thirdHeading = "Dispatched";
          this.orderDashboardDto.darkYellow = c.dispatched;
          this.orderDashboardDto.fourthHeading = "Received";
          this.orderDashboardDto.greenColor = c.received;
          this.orderDashboardDto.fifthHeading = "Total";
          this.orderDashboardDto.greyColor = c.totalOrders;
          this.orderDashboardDto.confirmed = c.confirmed;
          this.orderDashboardDto.declined = c.declined;
        }
      });
    }
  }

  onSelectReturnOrderType(invCode: string | number) {
    // Check if "All" is selected
    if (invCode === 'all') {
      let totalOrders = 0;
      let totalReceived = 0;

      // Iterate to accumulate orders and received counts
      this.returnOrdersList.forEach(c => {
        totalOrders += c.orders;
        totalReceived += c.received;
      });

      // Set values for "All" option
      this.returnOrderDashboardDto = {
        subHeading: 'All Returns',
        firstHeading: "UnResolved",
        redColor: 0,
        secondHeading: "In Process",
        lightYellow: totalOrders - totalReceived,
        thirdHeading: "Dispatched",
        darkYellow: 0,
        fourthHeading: "Received",
        greenColor: totalReceived,
        fifthHeading: "Total",
        greyColor: totalOrders
      };
    } else {
      // Find and set values for a specific inventory
      const selected = this.returnOrdersList.find(c => c.inventory === invCode);
      if (selected) {
        this.returnOrderDashboardDto = {
          subHeading: selected.inventoryName,
          firstHeading: "UnResolved",
          redColor: 0,
          secondHeading: "In Process",
          lightYellow: selected.orders - selected.received,
          thirdHeading: "Dispatched",
          darkYellow: 0,
          fourthHeading: "Received",
          greenColor: selected.received,
          fifthHeading: "Total",
          greyColor: selected.orders
        };
        this.name = selected.inventoryName;
      }
    }
  }

  setDataToDiv() {
    this.dashboardDtoForWebOrderList = [];
    this.dashboardDtoForTrackList = [];
    this.dashboardDtoForResponseList = [];
    // Web Order
    let webCommerce: MonitoringDashboardCommon = new MonitoringDashboardCommon();
    webCommerce.subHeading = "Web Commerce";
    webCommerce.firstHeading = "Wishlist";
    webCommerce.redColor = this.monitoringDashboardDto.webOrders.webCommerce.wishlist;
    webCommerce.secondHeading = "Cart"
    webCommerce.yellowColor = this.monitoringDashboardDto.webOrders.webCommerce.cart;
    webCommerce.thirdHeading = "Home Delivery"
    webCommerce.greenColor = this.monitoringDashboardDto.webOrders.webCommerce.homeDeliveryCheckouts;
    webCommerce.fourthHeading = "Store Pickup"
    webCommerce.greyColor = this.monitoringDashboardDto.webOrders.webCommerce.storePickupCheckout;
    this.dashboardDtoForWebOrderList.push(webCommerce)
    let checkouts: MonitoringDashboardCommon = new MonitoringDashboardCommon();
    checkouts.subHeading = "Checked Out Orders";
    checkouts.firstHeading = "Pending";
    checkouts.redColor = this.monitoringDashboardDto.webOrders.checkedOut.pending
    checkouts.secondHeading = "In Process"
    checkouts.yellowColor = this.monitoringDashboardDto.webOrders.checkedOut.inProcess;
    checkouts.thirdHeading = "Delivered"
    checkouts.greenColor = this.monitoringDashboardDto.webOrders.checkedOut.delivered;
    checkouts.fourthHeading = "Confirmed"
    checkouts.greyColor = this.monitoringDashboardDto.webOrders.checkedOut.confirmed;
    this.dashboardDtoForWebOrderList.push(checkouts)
    let customPrice: MonitoringDashboardCommon = new MonitoringDashboardCommon();
    customPrice.subHeading = "Custom Price";
    customPrice.firstHeading = "Deleted";
    customPrice.redColor = this.monitoringDashboardDto.webOrders.customPrice.deleted;
    customPrice.secondHeading = "In Queue"
    customPrice.yellowColor = this.monitoringDashboardDto.webOrders.customPrice.inQueue;
    customPrice.thirdHeading = "Responded"
    customPrice.greenColor = this.monitoringDashboardDto.webOrders.customPrice.responded;
    customPrice.fourthHeading = "Total"
    customPrice.greyColor = this.monitoringDashboardDto.webOrders.customPrice.total;
    this.dashboardDtoForWebOrderList.push(customPrice)
    let b2bCommerce: MonitoringDashboardCommon = new MonitoringDashboardCommon();
    b2bCommerce.subHeading = "B2B Commerce";
    b2bCommerce.firstHeading = "Wishlist";
    b2bCommerce.redColor = this.monitoringDashboardDto.webOrders.b2bCommerce.wishlist;
    b2bCommerce.secondHeading = "Cart"
    b2bCommerce.yellowColor = this.monitoringDashboardDto.webOrders.b2bCommerce.cart;
    b2bCommerce.thirdHeading = "CheckOut"
    b2bCommerce.greenColor = this.monitoringDashboardDto.webOrders.b2bCommerce.checkout;
    b2bCommerce.fourthHeading = "Total"
    b2bCommerce.greyColor = this.monitoringDashboardDto.webOrders.b2bCommerce.total;
    this.dashboardDtoForWebOrderList.push(b2bCommerce)
    let b2bCheckedOut: MonitoringDashboardCommon = new MonitoringDashboardCommon();
    b2bCheckedOut.subHeading = "B2B Checked Out Orders";
    b2bCheckedOut.firstHeading = "Pending";
    b2bCheckedOut.redColor = this.monitoringDashboardDto.webOrders.b2bCheckedOut.pending;
    b2bCheckedOut.secondHeading = "In Process"
    b2bCheckedOut.yellowColor = this.monitoringDashboardDto.webOrders.b2bCheckedOut.inProcess;
    b2bCheckedOut.thirdHeading = "Delivered"
    b2bCheckedOut.greenColor = this.monitoringDashboardDto.webOrders.b2bCheckedOut.delivered;
    b2bCheckedOut.fourthHeading = "Confirmed"
    b2bCheckedOut.greyColor = this.monitoringDashboardDto.webOrders.b2bCheckedOut.confirmed;
    this.dashboardDtoForWebOrderList.push(b2bCheckedOut)
    // Track Management
    let liveLocation: MonitoringDashboardCommon = new MonitoringDashboardCommon();
    liveLocation.subHeading = "Live Locations";
    liveLocation.firstHeading = "Offline";
    liveLocation.redColor = this.monitoringDashboardDto.tracks.locationLive.offline;
    liveLocation.secondHeading = "Online"
    liveLocation.yellowColor = this.monitoringDashboardDto.tracks.locationLive.online;
    liveLocation.thirdHeading = "Orders"
    liveLocation.greenColor = this.monitoringDashboardDto.tracks.locationLive.orders;
    liveLocation.fourthHeading = "Total Locations"
    liveLocation.greyColor = this.monitoringDashboardDto.tracks.locationLive.total;
    this.dashboardDtoForTrackList.push(liveLocation)
    let rider: MonitoringDashboardCommon = new MonitoringDashboardCommon();
    rider.subHeading = "Rider";
    rider.firstHeading = "Offline";
    rider.redColor = this.monitoringDashboardDto.tracks.rider.offline;
    rider.secondHeading = "Online"
    rider.yellowColor = this.monitoringDashboardDto.tracks.rider.online;
    rider.thirdHeading = "Orders"
    rider.greenColor = this.monitoringDashboardDto.tracks.rider.orders;
    rider.fourthHeading = "Total Riders"
    rider.greyColor = this.monitoringDashboardDto.tracks.rider.total;
    this.dashboardDtoForTrackList.push(rider)
    let digiboard: MonitoringDashboardCommon = new MonitoringDashboardCommon();
    digiboard.subHeading = "Digiboard";
    digiboard.firstHeading = "Offline";
    digiboard.redColor = this.monitoringDashboardDto.tracks.digiboard.offline;
    digiboard.secondHeading = "Online"
    digiboard.yellowColor = this.monitoringDashboardDto.tracks.digiboard.online;
    digiboard.thirdHeading = "Playing Content"
    digiboard.greenColor = this.monitoringDashboardDto.tracks.digiboard.playingContent;
    digiboard.fourthHeading = "Total"
    digiboard.greyColor = this.monitoringDashboardDto.tracks.digiboard.total;
    this.dashboardDtoForTrackList.push(digiboard)
    let customer: MonitoringDashboardCommon = new MonitoringDashboardCommon();
    customer.subHeading = "Customer";
    customer.firstHeading = "POS";
    customer.redColor = this.monitoringDashboardDto.tracks.customer.webCustomers;
    customer.secondHeading = "B2C"
    customer.yellowColor = this.monitoringDashboardDto.tracks.customer.cartCustomers;
    customer.thirdHeading = "B2B"
    customer.greenColor = this.monitoringDashboardDto.tracks.customer.b2bCustomers;
    customer.fourthHeading = "Total"
    customer.greyColor = this.monitoringDashboardDto.tracks.customer.totalCustomers;
    this.dashboardDtoForTrackList.push(customer)
    let couponRedemption: MonitoringDashboardCommon = new MonitoringDashboardCommon();
    couponRedemption.subHeading = "Coupon Redemption";
    couponRedemption.firstHeading = "Cancelled"
    couponRedemption.redColor = this.monitoringDashboardDto.tracks.couponRedemption.couponCancelled;
    couponRedemption.secondHeading = "Redeemed";
    couponRedemption.yellowColor = this.monitoringDashboardDto.tracks.couponRedemption.couponRedemption;
    couponRedemption.thirdHeading = "Total"
    couponRedemption.greenColor = this.monitoringDashboardDto.tracks.couponRedemption.totalCoupon;
    this.dashboardDtoForTrackList.push(couponRedemption)
    let spinWinRedemption: MonitoringDashboardCommon = new MonitoringDashboardCommon();
    spinWinRedemption.subHeading = "Spin N Win Redemption";
    spinWinRedemption.firstHeading = "Generated"
    spinWinRedemption.redColor = this.monitoringDashboardDto.tracks.spinWinRedemption.spinWinGeneration;
    spinWinRedemption.secondHeading = "Redeemed";
    spinWinRedemption.yellowColor = this.monitoringDashboardDto.tracks.spinWinRedemption.spinWinRedemption;
    spinWinRedemption.thirdHeading = "Total"
    spinWinRedemption.greenColor = this.monitoringDashboardDto.tracks.spinWinRedemption.totalSpinWin;
    this.dashboardDtoForTrackList.push(spinWinRedemption)
    let storeReporting: MonitoringDashboardCommon = new MonitoringDashboardCommon();
    storeReporting.subHeading = "Store Reporting";
    storeReporting.firstHeading = "Stores";
    storeReporting.redColor = this.monitoringDashboardDto.tracks.storeReporting.storeReporting;
    this.dashboardDtoForTrackList.push(storeReporting)
    // Response Management
    let storeFeedback: MonitoringDashboardCommon = new MonitoringDashboardCommon();
    storeFeedback.subHeading = "Store Feedback";
    storeFeedback.firstHeading = "Unresolved";
    storeFeedback.redColor = this.monitoringDashboardDto.responseManagement.storeFeedBack.unResolved;
    storeFeedback.secondHeading = "In Process"
    storeFeedback.yellowColor = this.monitoringDashboardDto.responseManagement.storeFeedBack.inProcess;
    storeFeedback.thirdHeading = "Resolved"
    storeFeedback.greenColor = this.monitoringDashboardDto.responseManagement.storeFeedBack.resolved;
    storeFeedback.fourthHeading = "Total"
    storeFeedback.greyColor = this.monitoringDashboardDto.responseManagement.storeFeedBack.total;
    this.dashboardDtoForResponseList.push(storeFeedback)
    let contactUs: MonitoringDashboardCommon = new MonitoringDashboardCommon();
    contactUs.subHeading = "Contact Us";
    contactUs.firstHeading = "Unresolved";
    contactUs.redColor = this.monitoringDashboardDto.responseManagement.contactUs.unResolved;
    contactUs.secondHeading = "In Process"
    contactUs.yellowColor = this.monitoringDashboardDto.responseManagement.contactUs.inProcess;
    contactUs.thirdHeading = "Resolved"
    contactUs.greenColor = this.monitoringDashboardDto.responseManagement.contactUs.resolved;
    contactUs.fourthHeading = "Total"
    contactUs.greyColor = this.monitoringDashboardDto.responseManagement.contactUs.total;
    this.dashboardDtoForResponseList.push(contactUs)
    let riderDiscrepency: MonitoringDashboardCommon = new MonitoringDashboardCommon();
    riderDiscrepency.subHeading = "Rider Discrepency";
    riderDiscrepency.firstHeading = "Unresolved";
    riderDiscrepency.redColor = this.monitoringDashboardDto.responseManagement.riderDiscrepency.unResolved;
    riderDiscrepency.secondHeading = "In Process"
    riderDiscrepency.yellowColor = this.monitoringDashboardDto.responseManagement.riderDiscrepency.inProcess;
    riderDiscrepency.thirdHeading = "Resolved"
    riderDiscrepency.greenColor = this.monitoringDashboardDto.responseManagement.riderDiscrepency.resolved;
    riderDiscrepency.fourthHeading = "Total"
    riderDiscrepency.greyColor = this.monitoringDashboardDto.responseManagement.riderDiscrepency.total;
    this.dashboardDtoForResponseList.push(riderDiscrepency)
    let whatsapp: MonitoringDashboardCommon = new MonitoringDashboardCommon();
    whatsapp.subHeading = "Whatsapp";
    whatsapp.firstHeading = "Not Responded";
    whatsapp.redColor = this.monitoringDashboardDto.responseManagement.whatsApp.notResponded;
    whatsapp.secondHeading = "In Process"
    whatsapp.yellowColor = this.monitoringDashboardDto.responseManagement.whatsApp.inProcess;
    whatsapp.thirdHeading = "Responded"
    whatsapp.greenColor = this.monitoringDashboardDto.responseManagement.whatsApp.responded;
    whatsapp.fourthHeading = "Total"
    whatsapp.greyColor = this.monitoringDashboardDto.responseManagement.whatsApp.total;
    this.dashboardDtoForResponseList.push(whatsapp)
    // Order Management

  }

  applyFlter(criteria: string) {
    this.activeSort = criteria;
    this.startTimer();
    this.getMonitoringDasboarddata(criteria);
  }

  getMonitoringDasboarddata(criteria: string) {
    this.updateFilterTypeSubscription = this.commonService.updateDashboardFilterType(this.apiUrl.updateDashboardFilterType, criteria).subscribe((data: any) => {
      if (data) {
        this.monitoringDashboardDto = data;
        this.setInitialDataToZero();
        this.isResponseReceived = true;
      }
    },
      (error: HttpErrorResponse) => {
        this.isResponseReceived = true;
        this.insertErrorLog("getMonitoringDasboarddata", error);
      });
  }

  isResponseReceived: boolean = false;
  startTimer(): void {
    // Clear the existing timer if any
    this.stopTimer();

    // Start a new interval timer that fetches data every 30 seconds
    this.timer = setInterval(() => {
      if (this.isResponseReceived) {
        this.isResponseReceived = false;
        this.getMonitoringDasboarddata(this.monitoringDashboardDto.tracks.storeReporting.filterType);
      }
    }, 30000); // 30000 ms = 30 seconds
  }

  stopTimer() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  insertErrorLog(errorMethod: string, error: HttpErrorResponse) {
    this.errorLog.userId = this.persistenceService.get('userId');
    this.errorLog.dateAndTime = moment(new Date()).format(this.constant.dateTimeFormatForDBServer);
    this.errorLog.moduleName = "Monitoring Dashboard";
    this.errorLog.errorMethod = errorMethod;
    this.errorLog.platform = "Web";
    if (error?.error?.message || error?.error?.message != '')
      this.errorLog.errorDetails = error.error.message;
    else
      this.errorLog.errorDetails = error.message;

    this.insertErrorLogSubscription = this.containerService.insertErrorLog(this.apiUrl.insertErrorLog, this.errorLog).subscribe((data: any) => {
    });
  }

  // subscribeToNotifications(id: any) {
  //   let stompClient = this.webSocketService.connect();

  //   stompClient.onConnect = (frame) => {
  //     console.log('Connected: ', frame);
  //     stompClient.subscribe('/topic/' + id + '/notification', (notifications: IMessage) => {
  //       try {
  //         this.monitoringDashboardDto = JSON.parse(notifications.body);
  //         this.activeSort = this.monitoringDashboardDto.tracks.storeReporting.filterType;
  //         console.log(this.monitoringDashboardDto);
  //         this.setInitialDataToZero();
  //         // this.toastService.showSuccessToast(notifications.body);
  //       } catch (error) {
  //         console.error('Error parsing notification:', error);
  //       }
  //     });

  //     // NEW Capital Food ORDERS
  //     stompClient.subscribe('/topic/' + 1 + '/notification', (message: IMessage) => {
  //       try {
  //         const data = JSON.parse(message.body);

  //         console.log("CF Order:", data);

  //         // Delegate to service (BEST PRACTICE)
  //         this.capitalFoodsComponent.handleIncomingOrder(data);

  //       } catch (error) {
  //         console.error('Error parsing CF order:', error);
  //       }
  //     });

  //   };

  //   stompClient.onStompError = (frame) => {
  //     console.error('Broker reported error:', frame.headers['message']);
  //     console.error('Additional details:', frame.body);
  //   };

  //   stompClient.activate(); // replaces stompClient.connect()

  // }

}